import React from "react";
import {
    Box,
    Radio,
    RadioGroup,
    FormControlLabel,
    FormControl,
    FormLabel,
    Typography,
    useTheme,
} from "@mui/material";

interface ProfessionalStatusStepProps {
    value: string;
    onChange: (value: string) => void;
}

// Define the options for professional status
const statusOptions = [
    { value: "student", label: "Student" },
    { value: "early-career", label: "Early Career Professional" }, // Consider better names later if needed
    { value: "mid-career", label: "Mid-Career Professional" },
    { value: "late-career", label: "Late Career Professional" },
    { value: "senior-executive", label: "Senior Executive" },
];

const ProfessionalStatusStep: React.FC<ProfessionalStatusStepProps> = ({ value, onChange }) => {
    const theme = useTheme(); // Access theme for colors like gold

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        onChange((event.target as HTMLInputElement).value);
    };

    return (
        <Box>
            <FormControl component="fieldset" fullWidth>
                <Typography variant="h6" gutterBottom align="center">
                    Where are you in your career journey?
                </Typography>
                <RadioGroup
                    aria-label="professional-status"
                    name="professionalStatus"
                    value={value}
                    onChange={handleChange}
                    sx={{ mt: 1 }} // Add some margin top
                >
                    {statusOptions.map((option) => (
                        <FormControlLabel
                            key={option.value}
                            value={option.value}
                            control={<Radio sx={{ display: "none" }} />} // Hide the actual radio button circle
                            label={option.label}
                            sx={{
                                border: `2px solid var(--primary-color)`, // Use CSS variable for border
                                borderRadius: "8px", // Rounded corners
                                padding: "12px 16px",
                                marginBottom: "12px", // Space between options
                                cursor: "pointer",
                                transition:
                                    "background-color 0.3s ease, border-color 0.3s ease, color 0.3s ease", // Added color transition
                                backgroundColor:
                                    value === option.value
                                        ? `var(--primary-color)` // Fill with primary color when selected
                                        : "transparent",
                                textAlign: "center", // Center text within the button

                                // Hover effect
                                "&:hover": {
                                    backgroundColor: `var(--primary-color)`, // Fill with primary color on hover
                                    borderColor: `var(--primary-color)`, // Ensure border stays consistent on hover
                                    ".MuiFormControlLabel-label": {
                                        // Target label color on hover
                                        color: `var(--white, #ffffff)`, // White text on hover (fallback white)
                                    },
                                },

                                // Styles for the label text itself
                                ".MuiFormControlLabel-label": {
                                    fontWeight: value === option.value ? "bold" : "normal",
                                    // Change text color, black/primary color by default, but if selected, white
                                    color:
                                        value === option.value
                                            ? `var(--white, #ffffff) !important`
                                            : `var(--text-color)`,
                                    transition: "color 0.3s ease", // Smooth color transition for text
                                },
                            }}
                        />
                    ))}
                </RadioGroup>
            </FormControl>
        </Box>
    );
};

export default ProfessionalStatusStep;
